import dayjs from 'dayjs'

export const getTimeNow = (): number => {
  return dayjs().unix()
}
